import { FilterChip, Flex, getPaletteColor } from 'pcln-design-system'
import { PushPin, PushPinBorder } from 'pcln-icons'
import styled from 'styled-components'

export const StyledPushPin = styled(PushPin)`
  color: ${getPaletteColor('promoSecondary.base')} !important;
`

export const StyledPushPinBorder = styled(PushPinBorder)`
  color: ${getPaletteColor('promoSecondary.base')} !important;
`

export const StyledFilterChip = styled(FilterChip)`
  margin: 0 2px 0 2px;
`

export const StyledPinChip = styled(FilterChip)`
  margin: 0 2px 0 2px;
`

export const DynamicFiltersWrapper = styled(Flex)`
  & button:not(#sort-listings) {
    z-index: 95 !important;

    @media only screen and (max-width: 768px) {
      display: none;
    }

    margin-bottom: 16px;
  }

  & > div {
    padding-top: 8px;
  }
`
